import {
  Controller,
  FieldValues,
  Path,
  UseControllerProps,
} from 'react-hook-form';
import {
  StyledDatePicker,
  StyledDatePickerProps,
} from './StyledDatePicker.tsx';

type HookFormStyledDatePickerProps<TFieldValues extends FieldValues> = Omit<
  StyledDatePickerProps & {
    control: UseControllerProps<TFieldValues>['control'];
    name: Path<TFieldValues>;
    rules?: UseControllerProps<TFieldValues>['rules'];
  },
  'value'
>;

export const HookFormStyledDatePicker = <TFieldValues extends FieldValues>(
  props: HookFormStyledDatePickerProps<TFieldValues>,
) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      render={({ field, fieldState }) => (
        <StyledDatePicker
          {...props}
          value={field.value}
          errorText={props.errorText ?? fieldState.error?.message}
          onChange={(e) => field.onChange(e)}
        />
      )}
    />
  );
};
